import { useUIStore } from '@/stores';
import {
  TitleScreen,
  MainMenu,
  SoloGameSetup,
  LocalGameSetup,
  OnlineGameSetup,
  GameBoard,
  SettingsModal,
  RulesModal,
  ViewportScaler,
  MenuMusic,
} from '@/components';
import { ToastContainer } from '@/components/ToastContainer';
import './App.css';

/**
 * App - アプリケーションルートコンポーネント
 * 画面遷移ロジックと各画面のレンダリングを管理
 */
function App() {
  const activeScreen = useUIStore((state) => state.activeScreen);

  return (
    <div className="app">
      {/* ビューポートスケーリング - 低解像度画面対応 */}
      <ViewportScaler />

      {/* メニュー系画面の BGM - 常時マウント（画面分岐の外） */}
      <MenuMusic />

      {activeScreen === 'title' && <TitleScreen />}
      {activeScreen === 'main_menu' && <MainMenu />}
      {activeScreen === 'solo_setup' && <SoloGameSetup />}
      {activeScreen === 'local_setup' && <LocalGameSetup />}
      {activeScreen === 'online_setup' && <OnlineGameSetup />}
      {activeScreen === 'game_board' && <GameBoard />}

      {/* 設定モーダル - どの画面からでもアクセス可能 */}
      <SettingsModal />

      {/* 遊び方モーダル - どの画面からでもアクセス可能 */}
      <RulesModal />

      {/* トースト通知 - 最前面に表示 */}
      <ToastContainer />
    </div>
  );
}

export default App;
